module.exports = __webpack_public_path__ + "img/Annals_of_hematology_cover.58b5338a.jpg";